import React, { useEffect, useRef } from "react";
import "./AIServices.css";
import AnimatedChart from "./AnimatedChart";

function AIServices() {
  const services = [
    {
      category: "AI & Machine Learning",
      items: [
        { name: "Artificial Intelligence (AI)", icon: "🤖" },
        { name: "Machine Learning (ML)", icon: "🧠" },
        { name: "Retrieval Augmented Generation (RAG)", icon: "🔍" },
        { name: "Agentic AI", icon: "🎯" },
        { name: "Generative AI", icon: "✨" },
        { name: "MLOps", icon: "⚙️" },
      ],
    },
    {
      category: "Cloud & Infrastructure",
      items: [
        { name: "Microsoft Azure", icon: "☁️" },
        { name: "Google Cloud Platform", icon: "🌐" },
        { name: "Amazon Web Services", icon: "📦" },
        { name: "Huawei Cloud", icon: "🌟" },
        { name: "Automation Services", icon: "🔄" },
      ],
    },
    {
      category: "Data & Analytics",
      items: [
        { name: "Data Analytics", icon: "📊" },
        { name: "Business Intelligence", icon: "💡" },
        { name: "Qlik Solutions", icon: "📈" },
        { name: "Power BI", icon: "📉" },
        { name: "Tableau", icon: "📐" },
      ],
    },
    {
      category: "Digital Solutions",
      items: [
        { name: "Website Design", icon: "🌐" },
        { name: "Mobile Applications", icon: "📱" },
        { name: "IT Services", icon: "💻" },
        { name: "IT Consulting", icon: "🤝" },
      ],
    },
  ];

  const observerRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll(".tech-category");
    elements.forEach((el) => observerRef.current.observe(el));

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <section id="ai-services" className="ai-services">
      <div className="container">
        <div className="section-title">
          <h2>Technology & AI Solutions</h2>
          <p>
            Leveraging cutting-edge technologies to transform your business
            operations
          </p>
        </div>

        <div className="tech-showcase">
          <div className="tech-grid">
            {services.map((category, index) => (
              <div key={index} className="tech-category">
                <h3>{category.category}</h3>
                <div className="tech-items">
                  {category.items.map((item, itemIndex) => (
                    <div key={itemIndex} className="tech-item">
                      <span className="tech-icon">{item.icon}</span>
                      <span className="tech-name">{item.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="tech-visualization">
            <AnimatedChart />
          </div>
        </div>

        <div className="ai-benefits">
          <h3>Why Choose Our Technology Solutions?</h3>
          <div className="benefits-grid">
            <div className="benefit">
              <div className="benefit-icon">🚀</div>
              <h4>Scalable Solutions</h4>
              <p>
                Our solutions grow with your business, ensuring long-term
                success
              </p>
            </div>
            <div className="benefit">
              <div className="benefit-icon">🔒</div>
              <h4>Enterprise Security</h4>
              <p>
                Bank-grade security measures to protect your data and operations
              </p>
            </div>
            <div className="benefit">
              <div className="benefit-icon">🌍</div>
              <h4>Global Standards</h4>
              <p>
                International best practices tailored for South African
                businesses
              </p>
            </div>
            <div className="benefit">
              <div className="benefit-icon">⚡</div>
              <h4>Rapid Deployment</h4>
              <p>
                Quick implementation with minimal disruption to your operations
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AIServices;
